import { render, staticRenderFns } from "./SelectingValuesTagging.vue?vue&type=template&id=2027f9ba&"
import script from "./SelectingValuesTagging.vue?vue&type=script&lang=js&"
export * from "./SelectingValuesTagging.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports